var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuestion = function SvgQuestion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#67647F",
    d: "M12 18a1 1 0 1 0 0-2 1 1 0 0 0 0 2M8.095 8.575C8.56 7.045 10.345 6 12 6c2.21 0 4 1.79 4 4 0 1.27-.729 1.865-1.548 2.534q-.174.141-.352.291c-.43.36-.865.875-1.2 1.625-.2.45-.6.55-.9.55-.55 0-1-.45-1-1 0-.75.535-1.34.96-1.745.255-.243.531-.465.795-.678C13.415 11.044 14 10.572 14 10c0-1.1-.9-2-2-2-.9 0-1.685.41-2.1 1.45-.1.25-.3.55-.9.55-.7 0-1-.4-1-1 0-.15.035-.295.095-.425"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#67647F",
    fillRule: "evenodd",
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8",
    clipRule: "evenodd"
  })));
};
export { SvgQuestion as ReactComponent };